import { gql, useQuery } from '@apollo/client';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';

export const GET_KWP_CONNECTION_INFO_QUERY = gql`
  query getInterfaceByQuery($payload: GetInterfaceInput!) {
    getInterfaceByQuery(payload: $payload) {
      _id
      interfaceName
      createdBy
      link
      codeVerifier
      codeChallenge
    }
  }
`;

export const useGetKWPConnectionByUserId = (userId?: string) => {
  const { account } = useGetCurrentAccount();

  const { data, loading } = useQuery(GET_KWP_CONNECTION_INFO_QUERY, {
    variables: {
      payload: {
        createdBy: userId || account?._id,
      },
    },
    skip: !account?._id,
    fetchPolicy: 'network-only',
  });

  return {
    interfaceConnection: data?.getInterfaceByQuery || null,
    loading,
  };
};
